import styled from 'styled-components';

export const StyledFooter = styled.footer`
  text-align: center;
  padding: 0 50px 12px;
  color: white;
  background-color: #151923;
  line-height: 1.4;
`;
